import { routes as aboutRoutes } from 'mk2/apps/about/routes';
import { routes as bazaarRoutes } from 'mk2/apps/bazaar/routes';
import { routes as blogsRoutes } from 'mk2/apps/blogs/routes';
import { routes as boRoutes } from 'mk2/apps/bo/routes';
import { routes as dashRoutes } from 'mk2/apps/dash/routes';
import { routes as forumRoutes } from 'mk2/apps/forum/routes';
import * as urls from 'mk2/apps/forum/urls';
import { routes as heartsRoutes } from 'mk2/apps/hearts/routes';
import { routes as homeRoutes } from 'mk2/apps/home/routes';
import { routes as mailRoutes } from 'mk2/apps/mail/routes';
import { routes as settingsRoutes } from 'mk2/apps/settings/routes';
import { routes as strollersRoutes } from 'mk2/apps/strollers/routes';
import { routes as usersRoutes } from 'mk2/apps/users/routes';
import { routes as wallRoutes } from 'mk2/apps/wall/routes';
import { routes as wikiRoutes } from 'mk2/apps/wiki/routes';
import { Route } from 'mk2/containers/Application/Application';
import NotFoundPage from 'mk2/pages/NotFoundPage';

export const routes: Route[] = [
    ...homeRoutes,
    ...forumRoutes,
    ...blogsRoutes,
    ...bazaarRoutes,
    ...usersRoutes,
    ...mailRoutes,
    ...wallRoutes,
    ...heartsRoutes,
    ...strollersRoutes,
    ...aboutRoutes,
    ...wikiRoutes,
    ...boRoutes,
    ...dashRoutes,
    ...settingsRoutes,
    {
        app: 'unknown',
        page: new NotFoundPage({ defaultBackPath: urls.forum }),
    },
];
